module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Listofplates#list"
    }
  }, [_vm._v("List of Plates")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Prologue#prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#chapter1"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Georgia and the Georgians")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Barbarossa")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Exiles")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Sonderverband "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bergmann")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Recruiting the Georgians")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Unreliable Allies")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07#chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Texel in Wartime")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08#chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Georgians and the Dutch")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09#chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Day of Birth")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The German Counter-Attack")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hunters and Hunted")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Where Were the Allies?")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Liberation")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Back in the USSR")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Making of a Myth")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Crucified Island")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter17#chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘A Country of Heroes’")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter18#chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Justice")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter19#chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("An Accounting")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Epilogue#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("In the ‘Russian Cemetery’")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix#appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Counting the Losses")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocat"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Acknowledgements#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0